<script>
import Markdown from '~/components/Markdown.vue';

export default {
    components: {
        Markdown,
    },
    props: {
        component: {
            type: Object,
            default: () => { },
        },
    },
};
</script>

<template>
    <Markdown
        :class="[component.style ? `style-${component.style}` : '', component.class ? component.class : '']"
        :markdown="component.content"
    />
</template>

<style scoped lang="scss"></style>
